import { Award, Users, Heart, Scissors } from "lucide-react";
import { Button } from "@/components/ui/button";

const WHATSAPP_NUMBER = "8898798857";

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_c6475175-9a65-4c2a-91e3-a6c8195373e3/artifacts/9vkfiwyz_WhatsApp%20Image%202026-01-18%20at%2012.03.00%20PM%20%281%29.jpeg";
const SALON_IMAGE_1 = "https://customer-assets.emergentagent.com/job_c6475175-9a65-4c2a-91e3-a6c8195373e3/artifacts/vqdnwizr_WhatsApp%20Image%202026-01-18%20at%2012.03.00%20PM%20%2810%29.jpeg";
const SALON_IMAGE_2 = "https://customer-assets.emergentagent.com/job_c6475175-9a65-4c2a-91e3-a6c8195373e3/artifacts/2c4is3jk_WhatsApp%20Image%202026-01-18%20at%2012.03.00%20PM%20%2812%29.jpeg";

const values = [
  {
    icon: Heart,
    title: "Personalised Care",
    description: "Every client receives individual attention and customised recommendations based on their unique hair type and lifestyle."
  },
  {
    icon: Award,
    title: "Expert Knowledge",
    description: "With over 20 years in the industry, we bring unmatched expertise in hair health, chemical treatments, and styling."
  },
  {
    icon: Users,
    title: "Family Friendly",
    description: "We welcome everyone – men, women, and kids – creating a comfortable environment for the whole family."
  },
  {
    icon: Scissors,
    title: "Quality First",
    description: "We use only premium, professional-grade products to ensure the best results and long-lasting hair health."
  }
];

export default function AboutPage() {
  const handleBookAppointment = () => {
    const message = encodeURIComponent("Hi, I'd like to book an appointment at Bunty Hair Master.");
    window.open(`https://wa.me/91${WHATSAPP_NUMBER}?text=${message}`, "_blank");
  };

  return (
    <div className="min-h-screen pt-20" data-testid="about-page">
      {/* Hero Section */}
      <section className="section-spacing bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto container-padding">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <p className="font-['Cormorant_Garamond'] text-[#D4AF37] text-sm tracking-[0.3em] uppercase mb-4">
                About Us
              </p>
              <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl text-white font-semibold leading-tight mb-6">
                The Story Behind{" "}
                <span className="gold-text">Bunty Hair Master</span>
              </h1>
              <p className="text-white/70 text-lg mb-6">
                Established in 2014, Bunty Hair Master has been Thane West's trusted destination 
                for premium hair and beauty services. What started as a passion project has grown 
                into a beloved salon serving families across the community.
              </p>
              <p className="text-white/60 mb-8">
                Our commitment to excellence, personalised service, and genuine care for our 
                clients has made us a standout choice for those who value quality in their 
                grooming experience.
              </p>
              <Button
                onClick={handleBookAppointment}
                className="bg-[#D4AF37] text-black hover:bg-[#B5952F] font-medium px-8 py-4 rounded-none shadow-[0_0_20px_rgba(212,175,55,0.3)]"
                data-testid="about-book-btn"
              >
                Book Your Visit
              </Button>
            </div>
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden">
                <img 
                  src={HERO_IMAGE}
                  alt="Bunty Hair Master Salon"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-[#121212] border border-[#D4AF37]/30 p-6">
                <p className="text-[#D4AF37] text-sm font-medium">Est. 2014</p>
                <p className="font-['Playfair_Display'] text-2xl text-white">Thane West</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="section-spacing bg-[#121212]">
        <div className="max-w-7xl mx-auto container-padding">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="order-2 lg:order-1">
              <div className="grid grid-cols-2 gap-4">
                <div className="aspect-[3/4] overflow-hidden">
                  <img 
                    src={SALON_IMAGE_1}
                    alt="Bunty Sir styling"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="aspect-[3/4] overflow-hidden mt-8">
                  <img 
                    src={SALON_IMAGE_2}
                    alt="Bunty Sir at work"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <p className="font-['Cormorant_Garamond'] text-[#D4AF37] text-sm tracking-[0.3em] uppercase mb-4">
                Meet The Founder
              </p>
              <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white font-semibold mb-6">
                Bunty Sir – 20+ Years of Expertise
              </h2>
              <div className="space-y-4 text-white/60">
                <p>
                  With over two decades of experience in hair styling and care, Bunty Sir 
                  has established himself as one of Thane's most trusted hair professionals.
                </p>
                <p>
                  His approach combines technical expertise with a deep understanding of 
                  individual client needs. Every consultation begins with a thorough assessment 
                  of hair health, texture, and face shape to deliver personalised recommendations.
                </p>
                <p>
                  Bunty Sir's specialisation in chemical treatments – from global colours to 
                  keratin treatments – has earned him a loyal clientele who trust his expertise 
                  for their most important transformations.
                </p>
                <p className="text-[#D4AF37] font-medium italic">
                  "Every head of hair tells a story. My job is to help you write the next 
                  beautiful chapter."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section-spacing bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto container-padding">
          <div className="text-center mb-12">
            <p className="font-['Cormorant_Garamond'] text-[#D4AF37] text-sm tracking-[0.3em] uppercase mb-4">
              Our Philosophy
            </p>
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white font-semibold">
              What We Stand For
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div 
                key={index}
                className="bg-[#121212] border border-white/5 p-8 hover:border-[#D4AF37]/30 transition-colors"
                data-testid={`value-card-${index}`}
              >
                <div className="w-14 h-14 bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center mb-6">
                  <value.icon className="w-7 h-7 text-[#D4AF37]" />
                </div>
                <h3 className="font-['Playfair_Display'] text-xl text-white mb-3">
                  {value.title}
                </h3>
                <p className="text-white/60 text-sm">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-spacing bg-[#121212]">
        <div className="max-w-4xl mx-auto container-padding text-center">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white font-semibold mb-6">
            Experience the Difference
          </h2>
          <p className="text-white/60 mb-8 max-w-2xl mx-auto">
            Join thousands of satisfied clients who have discovered the Bunty Hair Master 
            difference. Your transformation awaits.
          </p>
          <Button
            onClick={handleBookAppointment}
            className="bg-[#D4AF37] text-black hover:bg-[#B5952F] font-medium px-10 py-4 rounded-none text-lg shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.5)]"
            data-testid="about-cta-book-btn"
          >
            Book Your Appointment
          </Button>
        </div>
      </section>
    </div>
  );
}
